import type { ContextState, ContextToolState } from '../../../models/store/context/context.state'
import { getStateToolKey } from './get-state-tool-key'

export function mapToolStateToContext(
  state: ContextState,
  context: Partial<ContextToolState>,
): Partial<ContextToolState> {
  const toolKey = getStateToolKey(state)
  const toolState: ContextToolState = state[toolKey] ?? {}

  return {
    [toolKey]: {
      ...toolState,
      ...context,
      selectedFiltersValues: {
        ...toolState?.selectedFiltersValues,
        ...context.selectedFiltersValues,
      },
    },
  }
}
